import styled from "styled-components";
import React, { useState } from "react";

import { Button, Form, FormField, Input, Message } from "semantic-ui-react";
import { loginNoPWD, reset } from "../../redux/modules/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ErrorWrap } from "../../helpers/error";
import { routes } from "../../routes";
import { withRouter } from "react-router";
import { t } from "../../constant/translations";

type Props = {
  user?: Number,
  error?: Object,
  login?: Function,
  setField?: Function,
};

const StyledSubtext = styled.p`
  font-style: italic;
  margin: 6px 0 0 6px;
`;

const LoginComponent = ({ user, error, login, setField }: Props) => {
  const [data, setData] = useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    login(data.email);
  };

  setField = (name, value) => {
    const data = data || {};
    if (value) {
      data[name] = value;
    } else {
      delete data[name];
    }
    setData(data);
  };

  error = new ErrorWrap(error);
  return (
    <Form action="" onSubmit={onSubmit} error={error.exists()}>
      <FormField>
        <Input
          name="email"
          icon="mail"
          iconPosition="left"
          placeholder="Е-mail"
          error={error.exists()}
          onChange={(event) => setField("email", event.target.value)}
        />
        <StyledSubtext>{t("login.link_send")}</StyledSubtext>
      </FormField>
      <Message error content={error.getGlobal()} />
      <Button
        type="submit"
        fluid
        size="large"
        primary={true}
        disabled={!data.email}
      >
        {t("labels.enter")}
      </Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    error: state.auth.error,
    userKey: state.auth.userKey,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const loginNoPWDRedirect = (username) => {
    return (dispatch) =>
      dispatch(loginNoPWD(username)).then(
        () => {
          ownProps.history.replace(routes.authLoginSuccess);
        },
        (err) => {
          return err;
        }
      );
  };

  return bindActionCreators({ login: loginNoPWDRedirect, reset }, dispatch);
};
export const LoginNoPass = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginComponent)
);
